import { useContext, useState, useEffect } from 'react';
import { PcaMapContext } from '../../../contexts/PcaMapContext/PcaMapContext';

export const useIsStreetViewSupported = () => {
  const [isStreetViewSupported, setIsStreetViewSupported] = useState<boolean>(false);
  const { google, initialConfig } = useContext(PcaMapContext);
  const center = initialConfig?.center;

  useEffect(() => {
    if (!google || !center) return;

    const { StreetViewService, StreetViewSource, StreetViewStatus } = google.maps;
    const streetViewService = new StreetViewService();

    void streetViewService.getPanorama(
      {
        location: center,
        source: StreetViewSource.OUTDOOR,
      },
      (data, status) => {
        setIsStreetViewSupported(status === StreetViewStatus.OK);
      },
    );
  }, [google, center]);

  return isStreetViewSupported;
};
